/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2025-09-22 15:09:48
 * @LastEditors: wangqiong 2650366496@qq.com
 * @Description: System Logs 日志
 * @Do not edit
 */

import Home from "../pages/Home";
import InfoServices from "../pages/Solution/InfoServices";
import Archives from "../pages/Solution/Archives";
import Asset from "../pages/Solution/Asset";
import SpaceOperations from "../pages/Solution/SpaceOperations";
import KernelModulePage from "../pages/Solution/KernelModulePage"
import Residency from "../pages/Solution/Residency";
import Apply from "../pages/Apply";
import AboutUs from "../pages/AboutUs";
import Login from "../pages/Login";
import New from "../pages/New";
import ApplyFor from "../pages/ApplyFor";
import ImgManage from "../pages/ImgManage";
import General from "../pages/General";
import Recruit from "../pages/Backstage/Recruit/Recruit";
import SuccessStories from "../pages/SuccessStories";


let routers = [
    { path: "/", name: "home", component: Home, title: '首页', views: true },
    { path: "/home", name: "home", component: Home, title: '首页', views: true },
    { path: "/solution/infoServices", name: "infoServices", component: InfoServices, title: '产品服务', views: true },
    { path: "/solution/archives", name: "archives", component: Archives, title: '产品服务', views: true },
    { path: "/solution/asset", name: "asset", component: Asset, title: '产品服务', views: true },
    { path: "/solution/spaceOperations", name: "spaceOperations", component: SpaceOperations, title: '产品服务', views: true },
    { path: "/solution/KernelModulePage", name: "KernelModulePage", component: KernelModulePage, title: '产品服务', views: true },
    { path: "/solution/residency", name: "residency", component: Residency, title: '产品服务', views: true },
    { path: "/successStories", name: "successStories", component: SuccessStories, title: '成功案例', views: true },
    { path: "/aboutUs", name: "aboutUs", component: AboutUs, title: '关于我们', views: true },
    { path: "/apply", name: "apply", component: Apply, title: '在线体验', views: true },
    { path: "/login", name: "login", component: Login, title: '登录', views: true },
    { path: "/general", name: "general", component: General, title: '通用', views: true },
    { path: "/new", name: "new", component: New, title: '新闻', views: true },
    { path: "/imgManage", name: "imgManage", component: ImgManage, title: '图片管理', views: true },
    { path: "/applyFor", name: "applyFor", component: ApplyFor, title: '申请试用', views: true },
    { path: "/recruit", name: "recruit", component: Recruit, title: '招聘管理', views: true },
]

export default routers
